import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { COLOR_CONSTANTS } from 'theme'
import { sleep } from 'helpers'
import { Text } from './Typography'
import { Flex } from './Layout'

const RunningText = ({ text, onFinish, isNew }) => {
  const [writer, setWriter] = useState([])

  const generateWriter = async () => {
    const lines = text.split('\n\n')

    const transformData = []
    let lineCounter = 0
    for (const line of lines) {
      lineCounter++
      if (lineCounter > 1 && lineCounter !== lines.length) {
        transformData.push(`<br /><br />`)
        setWriter([...transformData])
        if (isNew) {
          await sleep(50)
        }
      }

      const words = line.split(' ')

      let wordsCounter = 0

      for (const word of words) {
        if (wordsCounter > 0 && wordsCounter !== words.length) {
          transformData.push(`<span style="background-color:${isNew ? '#e7f1ff' : 'transparent'}"> </span>`)
        }
        transformData.push(`<span style="background-color:${isNew ? '#e7f1ff' : 'transparent'}">${word}</span>`)
        setWriter([...transformData])
        if (isNew) {
          await sleep(50)
        }
        wordsCounter++
      }
      // }
    }
    onFinish()
  }

  useEffect(() => {
    if (text) {
      generateWriter()
    }
  }, [text])

  useEffect(() => {
    if (!isNew) {
      generateWriter()
    }
  }, [isNew])

  return (
    <Flex>
      <Text
        dangerouslySetInnerHTML={{
          __html: writer.join(''),
        }}
        textAlign="left"
        color={isNew ? 'primary' : COLOR_CONSTANTS.DENIM}
      />
    </Flex>
  )
}

RunningText.defaultProps = {
  isNew: false,
}

RunningText.propTypes = {
  text: PropTypes.string.isRequired,
  onFinish: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
}

export default RunningText
